module.exports = __webpack_public_path__ + "static/media/icon-wifi.550c1a8a.svg";